import { PrimaryAnnotatedType, TertiaryAnnotatedType } from '@/components/annotated-type';
import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { CenteredStoryText } from '@/components/microstory/text';
import { Trans, select, t } from '@lingui/macro';

export function GlobalCitizens2023Chapter2() {
  const answers = [
    {
      id: 'urban',
      label: t({
        id: 'global-citizens-2023.chapter-2.answer-1',
        message: 'Living in an urban area',
      }),
    },
    {
      id: 'education',
      label: t({
        id: 'global-citizens-2023.chapter-2.answer-2',
        message: 'Having tertiary education',
      }),
    },
    {
      id: 'internet',
      label: t({
        id: 'global-citizens-2023.chapter-2.answer-3',
        message: 'Having internet access',
      }),
    },
    {
      id: 'digital_sources',
      label: t({
        id: 'global-citizens-2023.chapter-2.answer-4',
        message: 'Getting info mainly from digital sources',
      }),
    },
  ];

  const { selectedAnswer, handleAnswer } = useStoryQuestion();

  return (
    <>
      <CenteredStoryText>
        <p>
          <Trans id="global-citizens-2023.chapter-2.text-3">
            Unlike older people, today’s{' '}
            <PrimaryAnnotatedType>15- to 24-year-olds</PrimaryAnnotatedType> have only ever known a
            world shaped by <TertiaryAnnotatedType>globalization</TertiaryAnnotatedType> and{' '}
            <TertiaryAnnotatedType>digital connectivity</TertiaryAnnotatedType>. Changes in the
            world at large may be driving shifts in identity.
          </Trans>
        </p>
      </CenteredStoryText>

      <StoryQuestion
        question={t({
          id: 'global-citizens-2023.chapter-2.question',
          message:
            'Besides age, what other factors make someone more likely to identify as a global citizen?',
        })}
        answers={answers}
        selectedAnswer={selectedAnswer}
        response={
          selectedAnswer?.id &&
          t({
            id: 'global-citizens-2023.chapter-2.question.response',
            message: select(selectedAnswer.id, {
              urban: "That's right!",
              education: 'Correct!',
              internet: "That's right!",
              digital_sources: 'Correct!',
            }),
          })
        }
        onAnswer={handleAnswer}
      />

      <CenteredStoryText>
        <p>
          <Trans id="global-citizens-2023.chapter-2.text-4">
            All four of these—<PrimaryAnnotatedType>living in a city</PrimaryAnnotatedType>,{' '}
            <PrimaryAnnotatedType>having post-secondary education</PrimaryAnnotatedType>,{' '}
            <PrimaryAnnotatedType>having internet access</PrimaryAnnotatedType>, and relying on{' '}
            <PrimaryAnnotatedType>digital info sources</PrimaryAnnotatedType>—help explain feelings
            of <TertiaryAnnotatedType>global citizenship</TertiaryAnnotatedType>.
          </Trans>
        </p>
      </CenteredStoryText>
    </>
  );
}
